module.exports = __webpack_public_path__ + "static/img/2-2.964ae573.png";